import React from 'react'

export default function Footer() {
    return (
        <>
            {/* start of footer */}
            <footer style={{ position: "relative" }}>
                <div>
                    <h2 className="text-primary text-center">Are you hungry?</h2>
                    <h1 className='text-primary-bold text-center'>Don't Wait!</h1>
                    <p className="text-muted text-center">
                        Let Start to find food by Calories...
                    </p>
                </div>
                
            </footer>
            {/* end of footer */}
        </>
    )
}
